import React from 'react';
import Chapter from './Odj/Chapter.js';
import LiveChapter from './Odj/LiveChapter.js';
import ScrollTo from '../../Utils/ScrollTo.js';
import Button from '@material-ui/core/Button';
import Utils from '../../Utils/Utils';
import { ButtonFiche } from '../Speaker';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';
import Alarm from '@material-ui/icons/Alarm';
import Close from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';

class SearchBar extends React.Component {

  styles = {
    input: {
      marginLeft: 8,
      flex: 1,
      width: 'calc(100% - 52px)',
      color: Utils.needWhiteText(window.theme.palette.primary.main) ? '#fff' : '#000',
      // background: window.theme.palette.background.paper,
    },
    iconButton: {
      padding: '4px 10px',
      color: Utils.needWhiteText(window.theme.palette.primary.main) ? '#fff' : '#000',
    }
  };

  state = {
    toSearch: true
  }

  handleChangeSearch = (e) => {
    if (this.inter)
      clearInterval(this.inter)
    this.setState({
      search: e.target.value
    })

    this.inter = setTimeout(() => {
      if (this.state.search.trim().length > 2) {
        this.setState({
          toSearch: false
        })
        let searchList = window.sdk.search(this.state.search)
        this.props.showSearch(searchList);
      }
    }, 300)

  }

  close = () => {
    if (!this.state.toSearch) {
      this.setState({
        toSearch: true,
        search: ''
      })
      this.props.showSearch([]);
    }
  }

  render() {
    return (
      <Paper elevation={1} id="search-box" style={{ background: window.theme.palette.primary.main }} >
          <InputBase style={this.styles.input} placeholder="Recherche" value={ this.state.search } onChange={ this.handleChangeSearch } id="search-input" />
          <IconButton onClick={ this.close } style={this.styles.iconButton} aria-label="Search" id="search-btn" >
          { this.state.toSearch &&
            <SearchIcon />
          }
          { !this.state.toSearch &&
            <Close />
          }
          </IconButton>
      </Paper>
    );
  }

}

export default class Odj extends React.Component {

  state = {
    chapters: [],
    currentChapterIndex: -1,
    show: true,
    isSearch: false,
    searchList: []
  }

  search = {
    backgroundColor: window.theme.palette.secondary.main,
    borderBottom: '1px solid #aaa'
  }

  searchItem = {
    color: 'white'
  }

  async mountVod() {
    let chapters = await window.sdk.getChapters(window.programId);
    let num = 0;
    Object.keys(chapters).map(function(key, index) {
      if(chapters[key].keywords !== 'speaker'){
        chapters[key].num = num;
        num++;
      }
    });
    this.setState({
      chapters: chapters
    })

    window.sdk.on('currentChapterIndex', (data) => {

      if(this.refs['chapter-' + data.index])
        this.refs['chapter-' + data.index].setCurrent(true);

      if (this.refs['chapter-' + data.oldIndex])
        this.refs['chapter-' + data.oldIndex].setCurrent(false);
      let chapter = window.sdk.getCurrentChapter();
      if(chapter && chapter.speaker) {
        window.sdk.showSpeaker(chapter);
      }
      if (chapter) {
        if(this.scroll)
          this.scroll.remove();
        this.scroll = new ScrollTo('chapter-' + chapter.id, 'tab_inner', this.state.show).go();
      }
      window.sdk.showSlide(chapter.slide_url);
    })

    window.sdk.on('currentChapterOdjIndex', (data) => {

      if (data.index) {
        this.refs['chapter-' + data.index].setCurrentOdj(true);
        /*
        var elements = document.querySelectorAll('.chapter-odj-' + data.index)
        Array.prototype.forEach.call(elements, function(el, i) {
          el.style.backgroundColor = Utils.hexToRGB(window.theme.palette.primary.main, 0.11)
          //el.style.borderRight = '3px solid ' + window.theme.palette.secondary.main;
        });
        */
      }
      if (data.oldIndex != -1) {
        this.refs['chapter-' + data.oldIndex].setCurrentOdj(false);
        /*
        var elements = document.querySelectorAll('.chapter-odj-' + data.oldIndex)
        Array.prototype.forEach.call(elements, function(el, i) {
          el.style.backgroundColor = "white";
        });
        */
      }
    })
  }
  
  async mountWaitLive() {
    this.setState({
      chapters: window.sdk.live.chapters
    })
  }

  async mountLive() {
    
    this.setState({
      chapters: window.sdk.live.chapters
    })
    
    window.sdk.on('refreshLiveOdj', () => {
      this.setState({
        chapters: window.sdk.live.chapters
      })
    });
    
    window.sdk.on('currentLiveIndex_chapter', (data) => {
		
		try {
          this.refs['chapter-speaker-' + this.currentSpeakerId].setCurrentOdj(false);
        }
        catch(err) {
         
        }
		
      if (data.index != -1) {
        this.refs['chapter-' + window.sdk.live.getCuepointByIndex('chapter', data.index).id].setCurrentOdj(true);
      }
      if (data.oldIndex != -1) {
        try {
          this.refs['chapter-' + window.sdk.live.getCuepointByIndex('chapter', data.oldIndex).id].setCurrentOdj(false);
        }
        catch(err) {
          
        }
      }
    });
    
    window.sdk.on('updateLive_chapter', (index) => {
      this.refs['chapter-' + window.sdk.live.getCuepointByIndex('chapter', index).id].updateData(window.sdk.live.getCuepointByIndex('chapter', index));
    })
    
    this.updateCurrentLiveChapter(window.sdk.live.getCurrentLive('chapter'));
    
    window.sdk.on('currentLive_chapter', (data) => {
      if(window.sdk.player().isLive() > -1) {
        this.updateCurrentLiveChapter(data.index);
        if(window.sdk.live.getCuepointByIndex('chapter', data.oldIndex)) {
          try {
            this.refs['chapter-' + window.sdk.live.getCuepointByIndex('chapter', data.oldIndex).id].setCurrentLive(false);
          }
          catch(err) {
            
          }
        }
      }
    })
    
    window.sdk.on('currentLiveIndex_speaker', (data) => {
      let index = data.index;
      if (index != -1) {
        let speaker = window.sdk.live.getCuepointDataByIdndex('speaker', index);
        console.log('speaker', speaker);
        
        try {
          this.refs['chapter-' + window.sdk.live.getCuepointByIndex('chapter', data.oldIndex).id].setCurrentLive(false);
        }
        catch(err) {
          
        }
        
        try {
          this.refs['chapter-speaker-' + this.currentSpeakerId].setCurrentOdj(false);
        }
        catch(err) {
         
        }
        
        let chapters = window.sdk.getLiveChaptersBySpeaker(speaker.value.speakerId);
        let goodChapter;
        for(var i in chapters) {
          //if(!chapters[i].duration) {
            if(chapters[i].live_second < window.sdk.player().dataTime.currentTime) 
              goodChapter = JSON.parse(JSON.stringify(chapters[i]));
          //}
          //if(chapters[i].duration > 0) {
          //  console.log(chapters[i].live_second, chapters[i].duration, window.sdk.player().dataTime.currentTime)
          //  if(chapters[i].live_second < window.sdk.player().dataTime.currentTime && (chapters[i].live_second + chapters[i].duration) > window.sdk.player().dataTime.currentTime) 
          //    goodChapter = JSON.parse(JSON.stringify(chapters[i]));
          //}
        }
        
        //if(!goodChapter)
        //  return;
        
        let liveChapter = parseInt(window.sdk.getCurrentChapter().id);
        goodChapter.chapterId = parseInt(goodChapter.chapterId);
        console.log('--->', goodChapter, liveChapter, goodChapter.chapterId)
        if(liveChapter != goodChapter.chapterId) {
          try {
            this.refs['chapter-speaker-' + goodChapter.id].setCurrentOdj(false);
            this.currentSpeakerId = goodChapter.id;
          }
          catch(err) {
            console.log('err', err);
          }
        }
        else {
          try {
              this.refs['chapter-speaker-' + goodChapter.id].setCurrentOdj(true);
              this.currentSpeakerId = goodChapter.id;
          }
          catch(err) {
            console.log('err', err);
          }
        }
        
        let speakerData = {
          title: speaker.value.speaker.firstname + ' ' + speaker.value.speaker.lastname,
          description: speaker.value.speaker.organization
        }
		
		this.first = true;
		
        if(this.first || !window.sdk.player().isLive())
          window.sdk.showSpeaker(speakerData, speaker);
        else
          this.first = true;
      }
    });
    
    /*window.sdk.on('updateLive_speaker', (index) => {
      console.log('updateLive_speaker', window.sdk.live.getCuepointByIndex('speaker', index));
      window.sdk.showSpeaker(window.sdk.live.getCuepointByIndex('speaker', index));
    })*/
    
  }
  
  updateCurrentLiveChapter(index) {
	  console.log('updateCurrentLiveChapter', index);
    let interval = setInterval(() => {
      if(!window.sdk.live.getCuepointByIndex('chapter', index))
        clearInterval(interval);
      
      if(index > -1 && !window.sdk.player().isVOD()) {
        let id = window.sdk.live.getCuepointByIndex('chapter', index).id;
        let ref = 'chapter-' + id;
        if(this.refs[ref]) {
          this.refs[ref].setCurrentLive(true);
          clearInterval(interval);
          if(window.sdk.player().isLive()) {
            if(this.scroll)
              this.scroll.remove();		 
		 console.log('scroll', id);
            this.scroll = new ScrollTo('chapter-' + id, 'tab_inner', this.state.show).go();
          }
        }
      }
    }, 300)
  }

  async componentDidMount() {

    if (window.live && this.props.liveOdj) {
      this.mountLive();
    }
    else if(window.live && !this.props.liveOdj) {
      this.mountWaitLive();
    }
    else {
      this.mountVod();
    }
    
    

  }

  showSearch = (searchList) => {
    if (searchList.length > 0) {
      this.setState({
        isSearch: true,
        searchList: searchList
      })
    }
    else {
      this.setState({
        isSearch: false,
        searchList: []
      })
    }
  }

  closeSearch() {

    this.refs['searchBar'].close();
  }

  show(value) {
    this.setState({
      show: value
    })
  }

  render() {
    
    let progressPieOdj = `@keyframes bg {  
        50% { 
          background: ${window.theme.palette.primary.main};
        }
      }
      #progress-chapter-odj {
        background-image: linear-gradient(to right, #fff 50%, ${window.theme.palette.primary.main} 50%)
      }
      .chapter-current .timeline-guide {
        border-color: ${window.theme.palette.primary.main} !important
      }
      @-webkit-keyframes pulse {
        0% {
          -webkit-box-shadow: 0 0 0 0 ${ Utils.hexToRGB(window.theme.palette.primary.main, 1)}
        }
        70% {
          -webkit-box-shadow: 0 0 0 5px ${ Utils.hexToRGB(window.theme.palette.primary.main, 0.4) }
        }
        100% {
          -webkit-box-shadow: 0 0 0 0 ${ Utils.hexToRGB(window.theme.palette.primary.main, 0.4) };
        }
      }`;
    
    let numChapter = 0;
    return (
      <div className={ ((!this.state.show) ? 'hide ' : '') + 'odj tab-odj-block' }>
      
        { window.sdk.isOverlay() &&<div className="tabs-overlay__close" onClick={(e) => { window.sdk.emit('closeTabs') }}>
          <Close style={{ color: window.theme.palette.background.txt }} /> 
        </div> }
        
        <style dangerouslySetInnerHTML={{__html: progressPieOdj}} />
        
        <div className="search-bar-container" id="search-bar-container">
          { !window.live && !window.sdk.isOverlay() &&
            <SearchBar ref="searchBar" showSearch={this.showSearch} />
          }
        </div>
        
        { this.state.isSearch &&
          <ul className="search-results">
            {this.state.searchList.map((chapter, index) => {
              return (
                 (chapter.chapter_type == 0) ? 
                 <ListItem className="search-results__item" key={ index } onClick={ () => { window.sdk.player().seek(chapter.start_second); this.closeSearch() }} style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)', backgroundColor: window.theme.palette.background.paper}}>
                  <ListItemText
                    style={{ padding: 0 }}
                    disableTypography
                    primary={ 
                      <Typography style={{ color: 'white' }} className="search_item_row">
                        <span style={{color: window.theme.palette.background.txt}}>
                          { chapter.title }
                        </span>
                        <span className="search_item_btn">
                          <span className="search_item">
                            <ButtonFiche background={ window.theme.palette.primary.main }>{ window.sdk.getDateFromSecond(chapter.start_second) } </ButtonFiche>
                          </span>
                        </span>
                      </Typography>  
                    }
                  />
                </ListItem> 
                : 
                null 
                );
            })}
            
          </ul>
        } 
  
        
        { window.live &&
          <List dense={ true }>
          {this.state.chapters.map(function(chapter, index){
              let liveChapter = null;
              if(window.sdk.live.getCuepointByIndex('chapter', index))
                liveChapter = window.sdk.live.getCuepointByIndex('chapter', index);
              
              return (
                <React.Fragment key={ index }>
                  <LiveChapter ref={'chapter-' + chapter.id } key={ 'chapter-'+index } num={ chapter.title ? ++numChapter : '' } chapter={ chapter } liveChapter={ liveChapter } className={'chapter-current-odj-' + chapter.id } />
                  {chapter.speakers.map(function(speaker, indexSpeaker){
                    //let liveChapterSpeaker = null;
                    //if(window.sdk.live.getCuepointByIndex('speaker', indexSpeaker))
                    //  liveChapterSpeaker = window.sdk.live.getCuepointByIndex('speaker', indexSpeaker);
                    return (
                      <LiveChapter speaker={ true } ref={'chapter-speaker-' + speaker.id } key={ 'speaker-'+indexSpeaker } chapter={ speaker } liveChapter={ null } className={'chapter-current-odj-' + chapter.id } />
                    )
                  })}
                </React.Fragment>
              );
          })}
          </List>
        }
        
        { !window.live &&
          <List dense={ true }>
          {this.state.chapters.map(function(chapter, index){
              return (chapter.chapter_type == 0) ? <Chapter ref={'chapter-' + index} key={ index } chapter={ chapter } /> : null
          })}
          </List>
        }
        
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/Player/Tabs/Odj.js